import { render } from "./agree-to-proceed-component.vue?vue&type=template&id=7902ac50"
import script from "./agree-to-proceed-component.vue?vue&type=script&lang=js"
export * from "./agree-to-proceed-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__